import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_platform.js";
//#region src/bite_platform_helper.ts
var bite_platform_helper_exports = /* @__PURE__ */ __exportAll({
	name: () => name,
	usesGarcon: () => usesGarcon
});
function name(platform) {
	switch (platform) {
		case "kiosk-ios": return "Kiosk iOS";
		case "kiosk-ios-garcon": return "Kiosk iOS Garcon";
		case "kiosk-android": return "Kiosk Android";
		case "kiosk-android-garcon": return "Kiosk Android Garcon";
		case "kiosk-signageos-garcon": return "Kiosk SignageOS Garcon";
		case "kiosk-chromeos-garcon": return "Kiosk ChromeOS Garcon";
		case "flash": return "Flash";
	}
}
function usesGarcon(platform) {
	switch (platform) {
		case "kiosk-android":
		case "kiosk-ios":
		case "flash": return false;
		case "kiosk-android-garcon":
		case "kiosk-chromeos-garcon":
		case "kiosk-ios-garcon":
		case "kiosk-signageos-garcon": return true;
	}
}
//#endregion
export { bite_platform_helper_exports, name, usesGarcon };

//# sourceMappingURL=bite_platform_helper.js.map